import $ from 'jquery';
import textBalancer from 'text-balancer';

export default function utils() {
	let $body = $('body');
	let links = document.querySelectorAll('a');
	let equalize_containers = document.querySelectorAll('.equalize-cells');
	
	// Clickable
	$body.on('click', '.clickable', function(event) {
		event.preventDefault();
		event.stopPropagation();

		var $tgt       = $(this),
			$a         = $tgt.find('a:first'),
			uri        = $a.attr('href'),
			new_window = $tgt.hasClass('external-link') || $a.hasClass('external-link') || event.metaKey || event.ctrlKey;

		if ( new_window ) {
			window.open(uri);
		} else {
			window.location = uri;
		}

		return false;
	});

	// External Links
	links.forEach( link => {
		link.addEventListener('click', function(event) {
			// get the href attribute
			let href = this.getAttribute('href');

			// get window origin
			let origin = window.location.origin;

			// check if the href starts with the origin
			if ( ! href.startsWith(origin) && ! href.startsWith('/') && ! href.startsWith('#') ) {
				// if not, stop the event and open the link in a new tab
				event.preventDefault();
				window.open(href);
			}

		});
	});

	// Run Text Balancer
	textBalancer.balanceText('.text-balance');

	// Equalizer function
	const equalize = (container) => {
		let cells = container.querySelectorAll('.equalize-cell');
		let heights = [];

		let stack_width = 1224;

		if ( container.classList.contains( 'equalize-cells-touch' ) ) {
			stack_width = 1023;
		}

		cells.forEach( cell => {
			// Remove inline height
			cell.style.height = '';
		});

		if ( window.innerWidth < stack_width ) {
			return;
		}

		cells.forEach( cell => {			
			heights.push(cell.offsetHeight);
		});

		let max_height = Math.max(...heights);

		cells.forEach( cell => {
			cell.style.height = max_height + 'px';
		});
	};

	// Equalizer
	if ( equalize_containers.length ) {
		equalize_containers.forEach( container => {
			equalize(container);
		});

		window.addEventListener('resize', function(e) {
			equalize_containers.forEach( container => {
				equalize(container);
			});
		});
	}
}